import type {
  Hor,
  POSTBaseHorBody,
  POSTRmcSingleHorBody,
} from '@/api/types/hor'

import { sliceApi } from './api'

export const horSliceApi = sliceApi.injectEndpoints({
  endpoints: (builder) => ({
    postSingleHorAsAdmin: builder.mutation<Hor, POSTBaseHorBody>({
      query: (body) => ({
        url: '/admin/hors',
        method: 'POST',
        body: { ...body, origin: 'outlook' },
      }),
    }),
    postSingleHorAsRmc: builder.mutation<Hor, POSTRmcSingleHorBody>({
      query: (body) => ({
        url: '/admin/rmc/hors',
        method: 'POST',
        body: { ...body, origin: 'outlook' },
      }),
    }),
  }),
  overrideExisting: false,
})

export const {
  usePostSingleHorAsAdminMutation,
  usePostSingleHorAsRmcMutation,
} = horSliceApi
